import {Typography} from "@mui/material"
import React from "react"
import styled from "styled-components"
import {FiberManualRecord} from "@mui/icons-material"

import {theme} from "@indebted/theme"
import {ContactInstruction} from "@indebted/api"

function ContactInstructions({instructions}: {instructions: ContactInstruction[]}) {
	return (
		<ContactInstructionsContainer>
			{instructions.map((instruction, index) => (
				<InstructionContainer key={index}>
					<SpanInlineBlock style={{paddingRight: "10px"}}>
						<BulletPointIcon />
					</SpanInlineBlock>

					<SpanInlineBlock>
						<ContactInstructionsTypography dangerouslySetInnerHTML={{__html: instruction.Content}} />
					</SpanInlineBlock>
				</InstructionContainer>
			))}
		</ContactInstructionsContainer>
	)
}

const ContactInstructionsContainer = styled.div`
	padding-left: 15px;
`

const InstructionContainer = styled.div`
	padding-bottom: 15px;
	display: flex;
`

const SpanInlineBlock = styled.span`
	display: inline-block;
`

const BulletPointIcon = styled(FiberManualRecord)`
	font-size: 10px;
`

const ContactInstructionsTypography = styled(Typography)`
	font-size: ${theme.typography.pxToRem(15)};
	i {
		color: ${theme.palette.text.secondary};
	}
`

export {ContactInstructions}
